import React from "react";
import {
  Box,
  Container,
  makeStyles,
} from "@material-ui/core";

import Page from "src/components/Page";
import View from "./View";
import PageHeader from "../../components/PageHeader";

import ReceiptIcon from "@material-ui/icons/Receipt";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#f7f7fa",
    minHeight: "100%",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
  },

  content: {
    marginTop: theme.spacing(3),
  },
}));

const Index = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Private Sale Receipt"
    >
      <Container maxWidth="lg">

        <PageHeader
          icon={<ReceiptIcon />}
          title="Private Sale Receipt"
          subtitle="Create and manage private sale receipts"
          showSession
        />

        <Box className={classes.content}>
          <View />
        </Box>

      </Container>
    </Page>
  );
};

export default Index;